import React, { useContext, useEffect, useState } from 'react'
import './TeamManagement.css'
import MaterialTable from 'material-table'
import { BsEye, BsSearch } from 'react-icons/bs';
import { SlPencil } from 'react-icons/sl';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import { AiOutlineDelete } from "react-icons/ai";
import { ThemeProvider, createTheme } from '@mui/material';
import { AiOutlineUserAdd } from "react-icons/ai";
import moment from 'moment';

import Modal from "react-modal";
import { contextData } from '../../../context/ContextProvider';
import { DELETE, GET, POST, PUT } from '../../Common/HttpMethods/HttpMethods';
import { Url } from '../../../constants/ApiUrlConstants';
import { useNavigate } from 'react-router-dom';
import FailModal from '../../Common/Popups/FailModal';
import SuccessModal from '../../Common/Popups/SuccessModal';
import { createTableIcons, customStylesAuditee, tableHeaderStyle } from '../../CommonCase/CommonFunctions';

export const handleDeleteTeamClick = (rowdata, setFailMessage, setOpenDeleteModal, setIdToDelete) => {
  if (rowdata?.source === "QMS") {
    setFailMessage("Are you sure you want to delete this team?");
    setOpenDeleteModal(true);
    setIdToDelete(rowdata?.teamId);
  }
};

export const ClearIndicator = (props) => {
  return <div />
}

export const handleEdit = async (id, source, setIsView, setLoading, setTeamDetailsById, setNewTeamInfo, newTeamInfo, setSessionExpiredModal, setFailMessage, setOpenFailModal, setIsEdited, token) => {
  setIsView(false)
  setIsEdited(true)
  try {
    setLoading(true);
    let pid = source == "QMS" ? 0 : id;
    let tid = source == "QMS" ? id : 0;
    const getTeamByIdResp = await GET(Url.getTeamDetails.replace('{projectId}', pid).replace('{qmsTeamId}', tid), token);


    if (getTeamByIdResp.SUCCESS) {
      setLoading(false);
      setTeamDetailsById(getTeamByIdResp?.DATA)

      const getData = getTeamByIdResp?.DATA



      setNewTeamInfo({
        ...newTeamInfo,
        teamId: getData?.teamId,
        teamName: getData?.teamName,
        teamAlias: '',
        teamEmpList: getData?.employeeMaster,
        startDate: new Date(getTeamByIdResp?.DATA?.parsedStartDate),
        endDate: new Date(getTeamByIdResp?.DATA?.parsedEndDate)
      })



    }
    else if (getTeamByIdResp.STATUS === 401) {
      setLoading(false)
      setSessionExpiredModal(true)
      setFailMessage("Session expired")
    }else if (getTeamByIdResp.STATUS === 400) {
      setLoading(false)
      setSessionExpiredModal(true)
      setFailMessage("Session expired")
    }else if (getTeamByIdResp.STATUS === 403) {
      setLoading(false)
      setSessionExpiredModal(true)
      setFailMessage("Session expired")
    }else if (getTeamByIdResp.STATUS === 404) {
      setLoading(false)
      setSessionExpiredModal(true)
      setFailMessage("Session expired")
    }else if (getTeamByIdResp.STATUS === 500) {
      setLoading(false)
      setSessionExpiredModal(true)
      setFailMessage("Session expired")
    }
    else {
      setLoading(false);
      setFailMessage("Failed to fetch teams");
      setOpenFailModal(true);
    }

  } catch (error) {
    console.error('Error:', error);
    setLoading(false);
    setOpenFailModal(true);
    setFailMessage("Failed to fetch teams.");
  }
}

export const getEmployeeData = async (setLoading, setAllEmployeeOptions, setSessionExpiredModal, setFailMessage, setOpenFailModal, token) => {
  try {
    setLoading(true);
    const getAllEmployee = await GET(Url.getEmployees, token);

    if (getAllEmployee.SUCCESS) {
      setLoading(false);

      const options = getAllEmployee?.DATA?.map((employee) => ({
        value: employee,
        label: employee.fullName,
      }));
      setAllEmployeeOptions(options);
    }
    else if (getAllEmployee.STATUS === 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (getAllEmployee.STATUS === 400) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (getAllEmployee.STATUS === 403) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (getAllEmployee.STATUS === 404) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (getAllEmployee.STATUS === 500) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }
    else {
      setLoading(false);
      setFailMessage("Failed to fetch Audit Table data.");
      setOpenFailModal(true);
    }

  } catch (error) {
    console.error('Error:', error);
    setLoading(false);
    setOpenFailModal(true);
    setFailMessage("Failed to fetch Audit table data.");
  }
};

export const getTeamList = async (setLoading, setTeamsList, setTeamsListCopy, setSessionExpiredModal, setFailMessage, setOpenFailModal, token) => {
  try {
    
    setLoading(true);
    const getTeamListResp = await GET(Url.getTeamList, token);

    if (getTeamListResp.SUCCESS) {
      setLoading(false);
      let data = getTeamListResp?.DATA.map((i, ind) => {
        let str = '';
        i?.employeeMaster?.map((j, index) => {
          let att = index === 0 ? j?.fullName : `, ${j?.fullName}`;
          str = str + att;
        });
        return {
          ...i,
          empString: str,
          index: ind + 1,
          parsedEndDate: `${i?.endDate[2]}/${i?.endDate[1]}/${i?.endDate[0]}`,
          parsedStartDate: `${i?.startDate[2]}/${i?.startDate[1]}/${i?.startDate[0]}`
        };
      });

      setTeamsList(data);
      setTeamsListCopy(data);
    } else if (getTeamListResp.STATUS === 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (getTeamListResp.STATUS === 400) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (getTeamListResp.STATUS === 403) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (getTeamListResp.STATUS === 404) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (getTeamListResp.STATUS === 500) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else {
      setLoading(false);
      setFailMessage("Failed to fetch teams");
      setOpenFailModal(true);
    }

  } catch (error) {
    console.error('Error:', error);
    setLoading(false);
    setOpenFailModal(true);
    setFailMessage("Failed to fetch teams.");
  }
};

export const submitEdit = async (
  newTeamInfo, setLoading, setCreateTeamOpen, setOpenSuccessModal, setSuccessMessage,
  setIsEdited, setNewTeamInfo, setNewTeamInfoError, setPinsStatus, setSearchInput,
  setSessionExpiredModal, setFailMessage, setOpenFailModal, token, emptyInfoObject, emptyTeamInfoError,
) => {
  const EditBody = {
    teamId: newTeamInfo?.teamId,
    teamName: newTeamInfo?.teamName,
    teamAlias: "",
    startDate: moment(newTeamInfo.startDate).format('YYYY-MM-DD'),
    endDate: moment(newTeamInfo.endDate).format('YYYY-MM-DD'),
    employeeMaster: newTeamInfo.teamEmpList,
  };

  try {
    const editSubmit = await POST(Url?.editQmsTeam, token, EditBody);

    if (editSubmit.SUCCESS) {
      setLoading(false);
      setCreateTeamOpen(false);
      setOpenSuccessModal(true);
      setSuccessMessage("Team Edited Successfully");
      setIsEdited(true);
      setNewTeamInfo(emptyInfoObject);
      setNewTeamInfoError(emptyTeamInfoError);
      setPinsStatus(false);
      setSearchInput("");
    } else if (editSubmit.STATUS === 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
      setNewTeamInfo(emptyInfoObject);
      setNewTeamInfoError(emptyTeamInfoError);
      setPinsStatus(false);
      setSearchInput("");
    }else if (editSubmit.STATUS === 400) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
      setNewTeamInfo(emptyInfoObject);
      setNewTeamInfoError(emptyTeamInfoError);
      setPinsStatus(false);
      setSearchInput("");
    }else if (editSubmit.STATUS === 403) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
      setNewTeamInfo(emptyInfoObject);
      setNewTeamInfoError(emptyTeamInfoError);
      setPinsStatus(false);
      setSearchInput("");
    }else if (editSubmit.STATUS === 404) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
      setNewTeamInfo(emptyInfoObject);
      setNewTeamInfoError(emptyTeamInfoError);
      setPinsStatus(false);
      setSearchInput("");
    }else if (editSubmit.STATUS === 500) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
      setNewTeamInfo(emptyInfoObject);
      setNewTeamInfoError(emptyTeamInfoError);
      setPinsStatus(false);
      setSearchInput("");
    } else {
      setLoading(false);
      setFailMessage("Failed to Edit team.");
      setOpenFailModal(true);
      setNewTeamInfo(emptyInfoObject);
      setNewTeamInfoError(emptyTeamInfoError);
      setPinsStatus(false);
    }
  } catch (error) {
    setLoading(false);
    setOpenFailModal(true);
    setFailMessage("Failed to edit team.");
  }
};

export const handleSelectChange = (
  name, e, newTeamInfo, setNewTeamInfo, newTeamInfoError, setNewTeamInfoError
) => {
  let value = e.target ? e.target.value : e;

  switch (name) {
    case "teamName":
      setNewTeamInfoError(prevState => {
        let errorMessage = null;
        if (/^\s/.test(value)) {
          errorMessage = "Input cannot have leading whitespace or be empty.";
        }
        return {
          ...prevState,
          teamName: errorMessage
        };
      });

      const formattedValue = value.charAt(0).toUpperCase() + value.slice(1);

      setNewTeamInfo(prevState => ({
        ...prevState,
        [name]: formattedValue ? formattedValue : null
      }));
      break;

    case "teamEmpList":
      setNewTeamInfoError(prevState => ({
        ...prevState,
        [name]: value && value.length > 0 ? null : "Required"
      }));
      setNewTeamInfo(prevState => ({
        ...prevState,
        [name]: value ? value.map(item => item.value) : []
      }));
      break;

    case "startDate":
    case "endDate":
      setNewTeamInfoError(prevState => ({
        ...prevState,
        [name]: value ? null : "Required"
      }));
      setNewTeamInfo(prevState => ({
        ...prevState,
        [name]: value ? value : null
      }));
      break;

    default:
      break;
  }
};


export const handleDateChange = (
  name,
  value,
  setNewTeamInfoError,
  setNewTeamInfo,
  setStartDatePickerOpen,
  setEndDatePickerOpen
) => {
  setNewTeamInfoError(prevState => ({
    ...prevState,
    [name]: value ? null : "Required"
  }));

  setNewTeamInfo(prevOptions => ({
    ...prevOptions,
    [name]: value
  }));

  if (name === "startDate") {
    setStartDatePickerOpen(false);
  } else if (name === "closingDate") {
    setEndDatePickerOpen(false);
  } else {
    console.error("Invalid date format");
    return;
  }
};

export const handleViewTeam = async (
  id,
  source,
  rowdata,
  setPinsStatus,
  setIsView,
  setCreateTeamOpen,
  setIsEdited,
  setLoading,
  setNewTeamInfo,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal,
  GET,
  Url,
  token,
  newTeamInfo
) => {
  if (source === "PINS") {
    setPinsStatus(true);
  }

  setIsView(true);
  setCreateTeamOpen(true);
  setIsEdited(false);

  try {
    setLoading(true);
    let pid = source === "QMS" ? 0 : id;
    let tid = source === "QMS" ? id : 0;
    const getTeamByIdResp = await GET(
      Url.getTeamDetails.replace("{projectId}", pid).replace("{qmsTeamId}", tid),
      token
    );

    if (getTeamByIdResp.SUCCESS) {
      setLoading(false);
      setNewTeamInfo({
        ...newTeamInfo,
        teamId: source === "QMS" ? getTeamByIdResp?.DATA?.teamId : getTeamByIdResp?.DATA?.projectID,
        teamName: source === "QMS" ? getTeamByIdResp?.DATA?.teamName : getTeamByIdResp?.DATA?.projectName,
        teamAlias: '',
        teamEmpList: getTeamByIdResp?.DATA?.employeeMaster,
        startDate: new Date(getTeamByIdResp?.DATA?.parsedStartDate),
        endDate: new Date(getTeamByIdResp?.DATA?.parsedEndDate)
      });
    } else if (getTeamByIdResp.STATUS === 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (getTeamByIdResp.STATUS === 400) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (getTeamByIdResp.STATUS === 403) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (getTeamByIdResp.STATUS === 404) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (getTeamByIdResp.STATUS === 500) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else {
      setLoading(false);
      setFailMessage("Failed to fetch teams");
      setOpenFailModal(true);
    }
  } catch (error) {
    console.error("Error:", error);
    setLoading(false);
    setOpenFailModal(true);
    setFailMessage("Failed to fetch teams.");
  }
};

export const handleDelete = async (
  idToDelete,
  DELETE,
  Url,
  token,
  setLoading,
  setOpenDeleteModal,
  setSuccessMessage,
  setOpenSuccessModal,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal,
  setSearchInput
) => {
  try {
    setOpenDeleteModal(false); // Close delete modal
    setLoading(true); // Set loading state to true

    // Perform delete API call
    const deleteQMSTeamResp = await DELETE(Url.deleteQmsTeam.replace("{qmsTeamId}", `${idToDelete}`), token);

    if (deleteQMSTeamResp.SUCCESS) {
      // If successful response
      setLoading(false);
      setSuccessMessage("Team deleted successfully.");
      setOpenSuccessModal(true);
      setSearchInput(""); // Reset search input
    } else if (deleteQMSTeamResp.STATUS == 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else if (deleteQMSTeamResp.STATUS == 400) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (deleteQMSTeamResp.STATUS == 403) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (deleteQMSTeamResp.STATUS == 404) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (deleteQMSTeamResp.STATUS == 500) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else {
      setLoading(false);
      setFailMessage("Failed to delete team");
      setOpenFailModal(true);
      setSearchInput(""); // Reset search input
    }
  } catch (error) {
    // Error handling
    setLoading(false);
    setFailMessage("Failed to delete team");
    setOpenFailModal(true);
  }
};

export const handleCreateTeam = async (
  newTeamInfo,
  teamsList,
  setLoading,
  setDuplicateTeamNameErr,
  setNewTeamInfoError,
  setCreateTeamOpen,
  setOpenSuccessModal,
  setNewTeamInfo,
  setSuccessMessage,
  setFailMessage,
  setOpenFailModal,
  setSessionExpiredModal,
  POST,
  Url,
  token
) => {
  let body = {
    "teamName": newTeamInfo?.teamName?.substring(0, 1).toUpperCase() + newTeamInfo?.teamName?.substring(1),
    "teamAlias": "",
    "startDate": moment(newTeamInfo.startDate).format('YYYY-MM-DD'),
    "endDate": moment(newTeamInfo.endDate).format('YYYY-MM-DD'),
    "employeeMaster": newTeamInfo.teamEmpList,
  }

  let hasError = false;

  // Check for duplicate team names
  teamsList.forEach((i) => {
    if (i.source == "QMS") {
      if (i?.teamName == body?.teamName) {
        setDuplicateTeamNameErr(true);
      }
    } else {
      if (i?.projectName == body?.teamName) {
        setDuplicateTeamNameErr(true);
      }
    }
  });

  // Validation checks
  if (body?.teamName == '' || body?.teamName == null) {
    setNewTeamInfoError(prevState => ({ ...prevState, teamName: "Required" }));
    hasError = true;
  } else if (/^\s/.test(body?.teamName)) {
    setNewTeamInfoError(prevState => ({ ...prevState, teamName: "Input cannot have leading whitespace or be empty." }));
    hasError = true;
  }

  if (body?.employeeMaster == [] || body.employeeMaster?.length === 0) {
    setNewTeamInfoError(prevState => ({ ...prevState, teamEmpList: "Required" }));
    hasError = true;
  }

  if (!body?.startDate || body?.startDate == "Invalid date") {
    setNewTeamInfoError(prevState => ({ ...prevState, startDate: "Required" }));
    hasError = true;
  }

  if (!body?.endDate || body?.endDate == "Invalid date") {
    setNewTeamInfoError(prevState => ({ ...prevState, endDate: "Required" }));
    hasError = true;
  }

  // If there are errors, return early
  if (hasError) {
    return;
  }

  try {
    setLoading(true);
    let createTeamResp = await POST(Url.addQmsTeam, token, body);

    // Handle different response cases
    if (createTeamResp.SUCCESS) {
      setLoading(false);
      setCreateTeamOpen(false);
      setOpenSuccessModal(true);
      setNewTeamInfo({});
      setNewTeamInfoError({});
      setSuccessMessage("New team created successfully");
    } else if (!createTeamResp.SUCCESS && createTeamResp.MESSAGE == "Team Name already present") {
      setLoading(false);
      setFailMessage("Team Name already present");
      setOpenFailModal(true);
      setNewTeamInfo({});
      setNewTeamInfoError({});
    } else if (createTeamResp?.STATUS == 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
      setNewTeamInfoError({});
    }else if (createTeamResp?.STATUS == 400) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
      setNewTeamInfoError({});
    }else if (createTeamResp?.STATUS == 403) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
      setNewTeamInfoError({});
    }else if (createTeamResp?.STATUS == 404) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
      setNewTeamInfoError({});
    }else if (createTeamResp?.STATUS == 500) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
      setNewTeamInfoError({});
    } else {
      setLoading(false);
      setFailMessage("Failed to add team.");
      setOpenFailModal(true);
      setNewTeamInfo({});
      setNewTeamInfoError({});
    }
  } catch (error) {
    setLoading(false);
    setFailMessage("Failed to add team.");
    setOpenFailModal(true);
    setNewTeamInfo({});
    setNewTeamInfoError({});
  }
};


export const CloseSuccesModal = (
  setOpenSuccessModal,
  getTeamList,
  setLoading,
  setTeamsList,
  setTeamsListCopy,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal,
  token,
  setNewTeamInfo,
  emptyInfoObject,
  setNewTeamInfoError,
  emptyTeamInfoError,
  setPinsStatus,
  setIsView,
  setIsEdited
) => {
  

  setOpenSuccessModal(false);
  getTeamList(setLoading, setTeamsList, setTeamsListCopy, setSessionExpiredModal, setFailMessage, setOpenFailModal, token);
  setNewTeamInfo(emptyInfoObject);
  setNewTeamInfoError(emptyTeamInfoError);
  setPinsStatus(false);
  setIsView(false);
  setIsEdited(false);
};

export const handleViewOkClick = (
  setCreateTeamOpen,
  setNewTeamInfo,
  emptyInfoObject,
  setPinsStatus,
  setNewTeamInfoError,
  emptyTeamInfoError,
  setIsView,
  setSearchInput
) => {
  setCreateTeamOpen(false);
  setNewTeamInfo(emptyInfoObject);
  setPinsStatus(false);
  setNewTeamInfoError(emptyTeamInfoError);
  setIsView(false);
  setSearchInput("");
};

export const handleSort = (
  field,
  sortedField,
  sortDirection,
  setSortedField,
  setSortDirection,
  teamsList,
  setTeamsList
) => {
  const newSortDirection = sortedField === field && sortDirection === 'asc' ? 'desc' : 'asc';
  setSortedField(field);
  setSortDirection(newSortDirection);

  // Sort data based on field and direction
  if (field === "source" || field?.includes("projectName") || field?.includes("teamName")) {
    const sortedData = teamsList?.slice().sort((a, b) => {
      if (a[field].toUpperCase() < b[field].toUpperCase()) return newSortDirection === 'asc' ? -1 : 1;
      if (a[field].toUpperCase() > b[field].toUpperCase()) return newSortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setTeamsList(sortedData);
  }

  if (field === "parsedEndDate") {
    const sortedData = teamsList.slice().sort((a, b) => {
      const dateA = new Date(a.endDate[1]);
      const dateB = new Date(b.endDate[1]);

      if (dateA < dateB) return newSortDirection === 'asc' ? -1 : 1;
      if (dateA > dateB) return newSortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setTeamsList(sortedData);
  }

  if (field === "parsedStartDate") {
    const sortedData = teamsList.slice().sort((a, b) => {
      const dateA = new Date(a.startDate[1]);
      const dateB = new Date(b.startDate[1]);

      if (dateA < dateB) return newSortDirection === 'asc' ? -1 : 1;
      if (dateA > dateB) return newSortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setTeamsList(sortedData);
  }
};

export const handleSessionExpClose = (navigate) => {
  sessionStorage.clear();
  navigate('/login');
};

export const handleCloseFailModel = (setOpenFailModal, setNewTeamInfo, emptyInfoObject, setNewTeamInfoError, emptyTeamInfoError, setPinsStatus, setIsView, setIsEdited) => {
  setOpenFailModal(false);
  setNewTeamInfo(emptyInfoObject);
  setNewTeamInfoError(emptyTeamInfoError);
  setPinsStatus(false);
  setIsView(false);
  setIsEdited(false);
};



const TeamManagement = () => {

  const navigate = useNavigate()

  const [teamsList, setTeamsList] = useState([]);
  const [teamsListCopy, setTeamsListCopy] = useState([]);
  const [isEdited, setIsEdited] = useState(false)
  const [pinsStatus, setPinsStatus] = useState(false)
  const [createTeamOpen, setCreateTeamOpen] = useState(false)

  const [searchInput, setSearchInput] = useState("")

  const [getAllEmployeeOptions, setAllEmployeeOptions] = useState([]);
  const [openSuccessModal, setOpenSuccessModal] = useState(false)
  const [successMessage, setSuccessMessage] = useState("")
  const [sessionExpiredModal, setSessionExpiredModal] = useState(false)
  const [failMessage, setFailMessage] = useState("");
  const [openFailModal, setOpenFailModal] = useState(false);
  const [isEndDatePickerOpen, setEndDatePickerOpen] = useState(false);
  const [isStartDatePickerOpen, setStartDatePickerOpen] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [idToDelete, setIdToDelete] = useState();
  const [isView, setIsView] = useState(false);
  const [duplicateTeamNameErr, setDuplicateTeamNameErr] = useState(false)

  const [sortedField, setSortedField] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');





  useEffect(() => {
    if (searchInput == "") {
      setTeamsList(teamsListCopy)
    }
    else {
      setTeamsList(teamsListCopy?.filter((i) => {

        // let res = []
        return (i?.teamName?.toLowerCase()?.includes(searchInput.toLowerCase()) || i?.projectName?.toLowerCase()?.includes(searchInput.toLowerCase()))
      }))
    }
  }, [searchInput])


  const [teamDetailsById, setTeamDetailsById] = useState();

  const { setLoading } = useContext(contextData);
  
  const [newTeamInfo, setNewTeamInfo] = useState({
    teamId: '',
    teamName: '',
    teamAlias: '',
    teamEmpList: [],
    startDate: null,
    endDate: null,
  });
  const [emptyInfoObject, setEmptyInfoObject] = useState({
    teamId: '',
    teamName: '',
    teamAlias: '',
    teamEmpList: [],
    startDate: null,
    endDate: null,
  });

  const [newTeamInfoError, setNewTeamInfoError] = useState({
    teamName: null,
    teamEmpList: null,
    startDate: null,
    endDate: null,
  });
  const [emptyTeamInfoError, setEmptyTeamInfoError] = useState({
    teamName: null,
    teamEmpList: null,
    startDate: null,
    endDate: null,
  });



  //  ==================================================================API integration ==============================================================

  const token = sessionStorage.getItem("TOKEN");


  // useEffect(()=>{
  //   getTeamList()
  // },[])




  // ======================================edit functionality========================








  useEffect(() => {
    getEmployeeData(setLoading, setAllEmployeeOptions, setSessionExpiredModal, setFailMessage, setOpenFailModal, token);
    getTeamList(setLoading, setTeamsList, setTeamsListCopy, setSessionExpiredModal, setFailMessage, setOpenFailModal, token);
  }, [])

  useEffect(() => {

  }, [newTeamInfo])





  const HandleCreateTeamOpen = () => {
    setIsEdited(false)
    setCreateTeamOpen(true)

  }



  const HandleCreateTeamClose = () => {

    setCreateTeamOpen(false);
    setNewTeamInfo(emptyInfoObject);
    setNewTeamInfoError(emptyTeamInfoError)
    setPinsStatus(false);
    setIsView(false);
    setIsEdited(false)
    setSearchInput("")
  }

  const modalKiStyle = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  const TableTheme = createTheme();



  const titleStyle = {
    borderRight: "1px solid #b8b8b8",
    cursor: "default",
  }

  const tableIconsTM = createTableIcons();



  const TeamsTableCol = [
    {
      title: <p>SR No.</p>,
      field: '',
      render: (rowdata) => (
        <div style={{ ...titleStyle, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingRight: '8px' }} className="Team-manage-table-row-data">
          {rowdata?.index}
        </div>

      )
    },
    {
      title: <p data-test-d='TeamName'>TEAM NAME</p>,
      field: 'teamName',
      sorting: true,
      render: (rowdata) => (
        <div style={{ ...titleStyle, position: "relative" }} className="Team-manage-table-row-data team-name-row">

          <span className="elipsisData" style={{ width: "255px", paddingLeft: '4px' }}>{rowdata?.source == "QMS" ? rowdata?.teamName : rowdata?.projectName}</span>
          {(rowdata?.teamName || rowdata?.projectName) &&
            <div className='teamname-tool-tip1'>
              {rowdata?.source == "QMS" ? rowdata?.teamName : rowdata?.projectName}
            </div>}
        </div>
      )
    },
    {
      title: <p>EMPLOYEE LIST</p>,
      field: 'EmployeeList',
      render: (rowdata) => (


        <div style={{ ...titleStyle, position: "relative" }} className="Team-manage-table-row-data team-list-row">
          <span className="elipsisData" style={{ width: "252px", paddingLeft: '4px' }}>{rowdata?.empString}</span>
          {rowdata?.empString &&
            <div className='teamlist-tool-tip1'>
              {rowdata?.empString}
            </div>}

        </div>
      )
    },
    {
      title: <p data-testid='STARTDATE'>START DATE</p>,
      field: 'parsedStartDate',
      // sorting: true,
      render: (rowdata) => (<div style={{ ...titleStyle, position: "relative" }} className="Team-manage-table-row-data">{rowdata?.parsedStartDate}</div>)
    },
    {
      title: <p data-testid='ENDDATE'>END DATE</p>,
      field: 'parsedEndDate',
      // sorting: true,
      render: (rowdata) => (<div style={{ ...titleStyle, position: "relative" }} className="Team-manage-table-row-data">{rowdata?.parsedEndDate}</div>)


    },
    {
      title: <p data-testid='SOURCE'>SOURCE</p>,
      field: 'source',
      sorting: true,
      render: (rowdata) => (<div style={{ ...titleStyle, position: "relative" }} className="Team-manage-table-row-data">{rowdata?.source}</div>)

    },
    {
      title: <p>STATUS</p>,
      field: 'projectStatus',
      sorting: true,
      render: (rowdata) => (<div style={{ ...titleStyle, position: "relative" }} className="Team-manage-table-row-data">{rowdata?.projectStatus}</div>)

    },


    {
      title: <p>ACTION</p>,
      field: '',
      render: (rowdata) => (


        <div style={{ ...titleStyle, display: 'flex', alignItems: "center", justifyContent: "center", width: "100%", borderRight: "none", paddingRight: '5px' }} className="Team-manage-table-row-data">
          <span style={{ display: 'flex', alignItems: "center", justifyContent: "space-evenly", width: "100%" }}>
            {<button onClick={() => { if (rowdata?.source == "QMS") { handleEdit(rowdata?.teamId, rowdata?.source, setIsView, setLoading, setTeamDetailsById, setNewTeamInfo, newTeamInfo, setSessionExpiredModal, setFailMessage, setOpenFailModal, setIsEdited, token); setCreateTeamOpen(true) } }} className={rowdata?.source == "QMS" ? "Team-ManageActionbutton" : "Team-ManageActionbuttonDisabled"} >
              <SlPencil size={12} />
              {/* <span className="TooltipText">Edit</span> */}
            </button>}
            <button className="Team-ManageActionbutton" onClick={() =>
              handleViewTeam(
                rowdata?.source === "QMS" ? rowdata?.teamId : rowdata?.projectID,
                rowdata?.source,
                rowdata,
                setPinsStatus,
                setIsView,
                setCreateTeamOpen,
                setIsEdited,
                setLoading,
                setNewTeamInfo,
                setSessionExpiredModal,
                setFailMessage,
                setOpenFailModal,
                GET,
                Url,
                token, newTeamInfo
              )
            } >
              <BsEye size={14} />
              {/* <span className="TooltipText">View</span> */}
            </button>
            {<button className={rowdata?.source == "QMS" ? "Team-ManageActionbutton" : "Team-ManageActionbuttonDisabled"} 
            // onClick={() => {
            //   if (rowdata?.source == "QMS") {
            //     setFailMessage("Are you sure you want to delete this team?")
            //     setOpenDeleteModal(true)
            //     setIdToDelete(rowdata?.teamId)

            //   }
            // }}
            onClick={() => {handleDeleteTeamClick(rowdata, setFailMessage, setOpenDeleteModal, setIdToDelete)}}
            >
              <AiOutlineDelete size={15} />
              {/* <span style={{ left: "5%" }} className="TooltipText">Delete</span> */}
            </button>}
          </span>
        </div >

      )

    }


  ]

  return (
    <div className='Team-Management-main-container'>
      <div className='Teams-create-btn-container'>
        <div className='serchbox'>
          <BsSearch fill='#999999' />
          <input type="text" placeholder='Search...' style={{ color: "black" }} value={searchInput} onChange={(e) => setSearchInput(e.target.value)} />
        </div>
        <button className='create-team-btn' data-testid="AiOutlineUserAdd" onClick={() => HandleCreateTeamOpen()}> < AiOutlineUserAdd size={14} /> Create Team </button>
      </div>
      <div data-testid='TM-MaterialTable' className='Teams-table-container'>
        <ThemeProvider theme={TableTheme}>
          <MaterialTable
            columns={TeamsTableCol}
            localization={{ body: { emptyDataSourceMessage: <span className="no_data_found_table">No Records to show</span> } }}
            data={teamsList}
            icons={tableIconsTM}
            SortArrow={true}
            options={{
              sorting: true,
              toolbar: false,
              draggable: false,
              search: false,
              pageSizeOptions: [5, 10, 15, 20],
              pageSize: 10,
              headerStyle: {
                position: 'sticky',
                top: -1,
                ...tableHeaderStyle
              },
              maxBodyHeight: '64vh',
              minBodyHeight: '64vh',
              backgroundColor: 'white',
            }}
            onColumnHeaderClick={(event, column) => {
              if (column.field) {
                handleSort(
                  column.field,
                  sortedField,
                  sortDirection,
                  setSortedField,
                  setSortDirection,
                  teamsList,
                  setTeamsList
                );
              }
            }}
          />
        </ThemeProvider>
      </div>

      <Modal
        isOpen={createTeamOpen}
        // onRequestClose={() => { HandleCreateTeamClose() }}
        style={modalKiStyle}
        contentLabel="Example Modal" >
        <div className="Team-management-inner-div">
          <div className="tb-modal-close-btn" data-testid="Team-management-inner-divHandleCreateTeamClose" onClick={() => { HandleCreateTeamClose() }}><span>X</span></div>

          <div className='TM-modal-info-cont'>
            <div className='TM-modal-header-cont'><h4>{isEdited ? "Edit Team" : (isView ? "View Team" : "Create New Team")}</h4></div>
            <hr style={{ borderTop: '0.5px solid #D0D0D0', borderBottom: 'none' }}></hr>
            <div className='TM-row1-Cont'>
              <div className='TM-label-cont' style={{ color: '#999999' }}>
                <span>Team Name<span style={{ color: 'red', fontSize: '14px' }}>*</span></span>
              </div>
              <div style={{ width: "100%", display: 'flex', flexDirection: 'column' }}>
                <input
                  data-testid='NewTeamName'
                  disabled={isView}
                  placeholder='Team Name...'
                  className='Team-name-input' value={newTeamInfo.teamName} name='teamName' onChange={(e) => handleSelectChange('teamName', e, newTeamInfo, setNewTeamInfo, newTeamInfoError, setNewTeamInfoError)} />
                {newTeamInfoError.teamName && <span style={{ color: 'red' }}>{newTeamInfoError.teamName}</span>}
              </div>
            </div>
            <div className='TM-row1-Cont'>
              <div className='TM-label-cont' style={{ color: '#999999' }}>
                <span>Employees<span style={{ color: 'red', fontSize: '14px' }}>*</span></span>
              </div>
              <div style={{ width: "100%", display: 'flex', flexDirection: 'column' }}>

                <Select
                  data-testid='TeammemberSelect'
                  value={newTeamInfo?.teamEmpList && newTeamInfo.teamEmpList.length > 0 ?
                    newTeamInfo.teamEmpList.map(emp => ({
                      label: `${emp.firstName} ${emp.lastName}`,
                      value: emp
                    })) : null}
                  name='teamEmpList'
                  disabled={isView}
                  onChange={(opt) => handleSelectChange('teamEmpList', opt, newTeamInfo, setNewTeamInfo, newTeamInfoError, setNewTeamInfoError)}
                  options={getAllEmployeeOptions}
                  className='TM-AuditorSelectDrop'
                  styles={customStylesAuditee}
                  isMulti={true}
                  components={{ ClearIndicator }}
                  isDisabled={isView}
                  placeholder="Select"
                />
                {newTeamInfoError.teamEmpList && <span style={{ color: 'red' }}>{newTeamInfoError.teamEmpList}</span>}

              </div>

            </div>
            <div>
              <div className='TM-row2-Cont'>
                <div className='TM-Start-Date-cont' style={{ display: pinsStatus == true && "none" }}>
                  <div style={{ width: " 40%", color: '#999999' }} >
                    <span>Start Date<span style={{ color: 'red', fontSize: '14px' }}>*</span></span>
                  </div>
                  <div style={{ width: "98%", display: 'flex', flexDirection: 'column' }}>
                    <div className='Audit-modal-datepicker' style={{ width: " 100%", }}>
                      <span style={{ marginRight: "12px", display: "flex", marginLeft: '5px', }}>
                        <svg
                          id="calendar-line-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="19.119px"
                          height="24.122px"
                          viewBox="0 0 27.119 27.122"
                        >
                          <path
                            id="Path_15922"
                            data-name="Path 15922"
                            d="M18.011,1.044A1.176,1.176,0,0,1,19.285,0a1.176,1.176,0,0,1,1.273,1.044V5.617a1.176,1.176,0,0,1-1.273,1.044,1.176,1.176,0,0,1-1.273-1.044V1.044ZM14.59,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,14.807c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,18.859c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM6.535,1.044A1.176,1.176,0,0,1,7.808,0,1.176,1.176,0,0,1,9.082,1.044V5.617A1.176,1.176,0,0,1,7.808,6.661,1.176,1.176,0,0,1,6.535,5.617V1.044ZM1.412,10H25.7V4.738a.652.652,0,0,0-.19-.457.644.644,0,0,0-.457-.19H22.732a.706.706,0,0,1,0-1.412H25.06a2.065,2.065,0,0,1,2.059,2.059V25.062a2.065,2.065,0,0,1-2.059,2.059h-23A2.065,2.065,0,0,1,0,25.06V4.738A2.065,2.065,0,0,1,2.059,2.679H4.546a.706.706,0,1,1,0,1.412H2.059a.652.652,0,0,0-.457.19.644.644,0,0,0-.19.457V10Zm24.294,1.415H1.412V25.06a.652.652,0,0,0,.19.457.644.644,0,0,0,.457.19h23a.652.652,0,0,0,.457-.19.644.644,0,0,0,.19-.457V11.417ZM11.13,4.092a.706.706,0,0,1,0-1.412h4.743a.706.706,0,0,1,0,1.412Z"
                            fill="#00aff1"
                          />
                        </svg>
                      </span>
                      <DatePicker id='TMOpenDatePicker'
                        data-testid='TM-StartDate'
                        selected={newTeamInfo?.startDate}
                        onChange={(date) => handleDateChange(
                          'startDate',
                          date,
                          setNewTeamInfoError,
                          setNewTeamInfo,
                          setStartDatePickerOpen,
                          setEndDatePickerOpen
                        )}
                        dateFormat='dd/MM/yyyy'
                        placeholderText='Start Date'
                        value={newTeamInfo?.startDate}
                        minDate={new Date()}
                        maxDate={newTeamInfo?.endDate}
                        disabled={isView}
                        popperProps={{ strategy: 'fixed' }}
                      />
                    </div>

                  </div>


                </div>
                <div className='TM-Start-Date-cont' style={{ display: pinsStatus == true && "none" }}>
                  <div style={{ width: " 36%", color: '#999999' }}><span>End Date<span style={{ color: 'red', fontSize: '14px' }}>*</span></span>
                  </div>
                  <div style={{ width: "100%", display: 'flex', flexDirection: 'column' }}>
                    <div className='Audit-modal-datepicker' style={{ width: " 100%" }}>
                      <span style={{ marginRight: "12px", display: "flex", marginLeft: '5px', }}>
                        <svg
                          id="calendar-line-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="19.119px"
                          height="24.122px"
                          viewBox="0 0 27.119 27.122"
                        >
                          <path
                            id="Path_15922"
                            data-name="Path 15922"
                            d="M18.011,1.044A1.176,1.176,0,0,1,19.285,0a1.176,1.176,0,0,1,1.273,1.044V5.617a1.176,1.176,0,0,1-1.273,1.044,1.176,1.176,0,0,1-1.273-1.044V1.044ZM14.59,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,14.807c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,18.859c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM6.535,1.044A1.176,1.176,0,0,1,7.808,0,1.176,1.176,0,0,1,9.082,1.044V5.617A1.176,1.176,0,0,1,7.808,6.661,1.176,1.176,0,0,1,6.535,5.617V1.044ZM1.412,10H25.7V4.738a.652.652,0,0,0-.19-.457.644.644,0,0,0-.457-.19H22.732a.706.706,0,0,1,0-1.412H25.06a2.065,2.065,0,0,1,2.059,2.059V25.062a2.065,2.065,0,0,1-2.059,2.059h-23A2.065,2.065,0,0,1,0,25.06V4.738A2.065,2.065,0,0,1,2.059,2.679H4.546a.706.706,0,1,1,0,1.412H2.059a.652.652,0,0,0-.457.19.644.644,0,0,0-.19.457V10Zm24.294,1.415H1.412V25.06a.652.652,0,0,0,.19.457.644.644,0,0,0,.457.19h23a.652.652,0,0,0,.457-.19.644.644,0,0,0,.19-.457V11.417ZM11.13,4.092a.706.706,0,0,1,0-1.412h4.743a.706.706,0,0,1,0,1.412Z"
                            fill="#00aff1"
                          />
                        </svg>
                      </span>
                      <DatePicker id='TMOpenDatePicker'
                        data-testid='TM-EndDate'
                        selected={newTeamInfo?.endDate}
                        onChange={(date) => handleDateChange(
                          'endDate',
                          date,
                          setNewTeamInfoError,
                          setNewTeamInfo,
                          setStartDatePickerOpen,
                          setEndDatePickerOpen
                        )}
                        dateFormat='dd/MM/yyyy'
                        placeholderText='End Date'
                        value={newTeamInfo?.endDate}
                        minDate={newTeamInfo?.startDate}
                        disabled={isView}
                        popperProps={{ strategy: 'fixed' }}
                      />
                    </div>

                  </div>

                </div>

              </div>
              <div className='TM-row2-Cont'>
                <div className='TM-Start-Date-cont' >  {newTeamInfoError.startDate && <span style={{ color: 'red' }}>{newTeamInfoError.startDate}</span>}</div>
                <div className='TM-Start-Date-cont'> {newTeamInfoError.endDate && <span style={{ color: 'red' }}>{newTeamInfoError.endDate}</span>}</div>
              </div>
            </div>
            <div className="task-modal-ok-btn">
              <button
                onClick={isEdited
                  ? () => submitEdit(
                    newTeamInfo, setLoading, setCreateTeamOpen, setOpenSuccessModal, setSuccessMessage,
                    setIsEdited, setNewTeamInfo, setNewTeamInfoError, setPinsStatus, setSearchInput,
                    setSessionExpiredModal, setFailMessage, setOpenFailModal, token, emptyTeamInfoError, emptyInfoObject
                  )
                  : !isView
                    ? () => handleCreateTeam(
                      newTeamInfo,
                      teamsList,
                      setLoading,
                      setDuplicateTeamNameErr,
                      setNewTeamInfoError,
                      setCreateTeamOpen,
                      setOpenSuccessModal,
                      setNewTeamInfo,
                      setSuccessMessage,
                      setFailMessage,
                      setOpenFailModal,
                      setSessionExpiredModal,
                      POST,
                      Url,
                      token
                    )
                    :()=> handleViewOkClick(
                      setCreateTeamOpen,
                      setNewTeamInfo,
                      emptyInfoObject,
                      setPinsStatus,
                      setNewTeamInfoError,
                      emptyTeamInfoError,
                      setIsView,
                      setSearchInput
                    )
                }
              >
                {isEdited ? "Edit" : (isView ? "OK" : "Create")}
              </button>

            </div>

          </div>
        </div>
      </Modal >


      <FailModal
        openFailModal={sessionExpiredModal}
        setOpenFailModal={setSessionExpiredModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() => handleSessionExpClose(navigate)}
        recallFunctiononClose={() => handleSessionExpClose(navigate)}
      />

      <FailModal
        openFailModal={openFailModal}
        setOpenFailModal={setOpenFailModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() => handleCloseFailModel(setOpenFailModal, setNewTeamInfo, emptyInfoObject, setNewTeamInfoError, emptyTeamInfoError, setPinsStatus, setIsView, setIsEdited)}
        recallFunctiononClose={() => handleCloseFailModel(setOpenFailModal, setNewTeamInfo, emptyInfoObject, setNewTeamInfoError, emptyTeamInfoError, setPinsStatus, setIsView, setIsEdited)}
      />


      {/* //////////////POPUP for delete */}
      <FailModal
        openFailModal={openDeleteModal}
        setOpenFailModal={setOpenDeleteModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() => handleDelete(
          idToDelete, // idToDelete, pass your dynamic id here
          DELETE,
          Url,
          token,
          setLoading,
          setOpenDeleteModal,
          setSuccessMessage,
          setOpenSuccessModal,
          setSessionExpiredModal,
          setFailMessage,
          setOpenFailModal,
          setSearchInput
        )}
        recallFunctiononClose={() => handleCloseFailModel(setOpenFailModal, setNewTeamInfo, emptyInfoObject, setNewTeamInfoError, emptyTeamInfoError, setPinsStatus, setIsView, setIsEdited)}
      />

      <SuccessModal
        openSuccessModal={openSuccessModal}
        setOpenSuccessModal={setOpenSuccessModal}
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
        recallFunctionOnOk={()=>{getTeamList(setLoading, setTeamsList, setTeamsListCopy, setSessionExpiredModal, setFailMessage, setOpenFailModal, token)}}
        recallFunctionOnClose={() =>
          CloseSuccesModal(
            setOpenSuccessModal,
            getTeamList,
            setLoading,
            setTeamsList,
            setTeamsListCopy,
            setSessionExpiredModal,
            setFailMessage,
            setOpenFailModal,
            token,
            setNewTeamInfo,
            emptyInfoObject,
            setNewTeamInfoError,
            emptyTeamInfoError,
            setPinsStatus,
            setIsView,
            setIsEdited
          )}
      />

    </div >
  )
}

export default TeamManagement